import React from 'react';
import { IConcreteJobConfirmationPopupProperties, IJobResultComponentProps } from '../jobs-monitor-host.viewmodel';
import { IEventBlueprintTriggerJobDetails, IEventBlueprintTriggerJobResults } from '../../../api/jobs.dao';

const eventBlueprintTriggerJobProperties:
    IConcreteJobConfirmationPopupProperties<IJobResultComponentProps<IEventBlueprintTriggerJobDetails, IEventBlueprintTriggerJobResults>> = {
    reviewCompletedJobButtonText: 'Ok',
    reviewFailedJobButtonText: 'Ok',
    completeComponent: () => {
        return <span className='alert-message'>Event setup is complete</span>;
    },
    failedComponent: () => {
        return <span className='alert-message'>Event setup is failed</span>;
    }
};

export { eventBlueprintTriggerJobProperties };
